import {get, post} from '../index'
export default {

  getAccountList (querys) {
    return get('/admin/userAdmin/list', querys)
  },

  getAccountMenuList () {
    return get('/admin/userAdmin/menuList')
  },
  // 邀请奖励列表
  getinviteListsda (querys) {
    return get('/agent/user/inviteList', querys)
  },
  // 获取公司信息
  getcompanyInfo (querys) {
    return get('/agent/user/companyInfo', querys)
  },
  // 公司信息-提交
  postsaveCompany (querys) {
    return post('/agent/user/saveCompany', querys)
  },
  // 邀请有礼-活动介绍
  getinviteIntroduction (querys) {
    return get('/agent/user/inviteIntroduction', querys)
  },
  createAccountInfo (querys) {
    return post('/admin/userAdmin/addUserAdmin', querys)
  },

  editAccountInfo (querys) {
    return post('/admin/userAdmin/updateUserAdmin',querys)
  },
  delAccountInfo (querys) {
    return post('/admin/userAdmin/delUserAdmin',querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/account.js